import api from '@axios'

class Deposit {
  // Deposit by using PayPal "CAPTURE ORDER"
  static async paypal(orderID) {
    const {
      data
    } = await api.post(`/deposit/paypal/${orderID}`)
    return data
  }

  static async binance(orderID) {
    const {
      data
    } = await api.post(`/deposit/binance_orderId/${orderID}`)
    return data
  }

  // Deposit by using Stripe
  static async stripeVerify(tokenID, bodyData) {
    const {
      data
    } = await api.post(`/deposit/stripe/verify/${tokenID}`, bodyData)
    return data
  }

  // Stripe Generate Session
  static async stripeCreateSession(bodyData) {
    const {
      data
    } = await api.post(`/deposit/stripe/generate-session`, bodyData)
    return data
  }

  static async revolutCreateOrder(bodyData) {
    const {
      data
    } = await api.post(`/deposit/generate-revolut-order`, bodyData)
    return data
  }

  static async verifyRevolutOrder(orderId) {
    const {
      data
    } = await api.get(`/verify-revolut-order/${orderId}`)
    return data
  }

  // Which payment methods are currently enabled (admin kill switch).
  // Returns a { method_key: bool } map; absent keys are treated as enabled.
  static async enabledMethods() {
    const {
      data
    } = await api.get(`/deposit/methods`)
    return data
  }

  // ADMIN: full toggle state { methods: {...}, labels: {...} }
  static async adminGetMethods() {
    const {
      data
    } = await api.get(`/admin/payment-methods`)
    return data
  }

  // ADMIN: enable/disable one method
  static async adminSetMethod(method_key, enabled) {
    const {
      data
    } = await api.put(`/admin/payment-methods`, { method_key, enabled })
    return data
  }

}

export default Deposit